import { FC, Fragment } from 'react';

import { contentDictonary } from '../../constants/no-tickets';
import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import FanMember from '../IdentifyMember';
import * as Styles from './noTickets.styles';

const EmptyState: FC = () => {
  const { translate } = useI18nContext();
  const { isFootball, noTicketContentKey } = useEventContext();

  return (
    <Fragment>
      {isFootball && <FanMember size="30%" />}
      <Styles.NoTickets
        $reduceHeight={isFootball}
        id="empty-state-no-tickets"
      >
        <Styles.Image
          src={contentDictonary[noTicketContentKey].image}
          alt="No tickets"
          id="empty-state-image"
        />
        <Styles.Title id="empty-state-title">
          {translate(contentDictonary[noTicketContentKey].title)}
        </Styles.Title>
        <Styles.Subtitle id="empty-state-subtitle">
          {translate(contentDictonary[noTicketContentKey].subtitle)}
        </Styles.Subtitle>
      </Styles.NoTickets>
    </Fragment>
  );
};

export default EmptyState;
